<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<div class="select-conversion">
  <!--Item 1-->
  <xrx-select
    [label]="label"
    [inlineLabel]="inlineLabel"
    [list]="list"
    [localize]="localize"
    [property]="property"
    [sort]="false"
    [(selectedItem)]="selectedItem"
    (change)="
      change.emit(selectedItem); doValidate(selectedItem, selectedItem2)
    "
    [required]="required"
    [error]="error"></xrx-select>

  <!-- Converted to-->
  <div>
    <div class="xgl-arrow" [ngClass]="{ 'lower-arrow': label }"></div>
  </div>

  <!--Item 2-->
  <xrx-select
    [label]="label2"
    [inlineLabel]="inlineLabel2"
    [list]="list2"
    [localize]="localize"
    [property]="property"
    [orderby]="orderby"
    [(selectedItem)]="selectedItem2"
    (change)="
      change2.emit(selectedItem2); doValidate(selectedItem, selectedItem2)
    "
    [required]="required"
    [error]="error"></xrx-select>
</div>
@if (selectedItem?.value === selectedItem2?.value) {
  <div>
    <span
      class="text-danger"
      [xdaTranslate]="'SDE_INPUT_LANGUAGE_OUTPUT'"></span>
  </div>
}
@if (selectedItem?.value !== selectedItem2?.value) {
  <div><span [xdaTranslate]="description"></span></div>
}
